import ServiceTemplate from '@/components/ServiceTemplate';

export default function CompanyNameChange() {
  const data = {
    title: 'Company Name Change Services',
    subtitle: 'Professional business name change services with complete filing and compliance support.',
    overviewTitle: 'Changing Your Company Name',
    overviewImage: 'https://images.unsplash.com/photo-1507925921958-8a62f3d1a50d',
    description: [
      'Changing your company\'s legal name requires amendments to formation documents, updating state records, and notifying various agencies and stakeholders. Proper handling ensures continuity of business operations.',
      'We manage the entire name change process including availability checks, state amendments, EIN updates, and coordination with banks and other institutions.',
      'Our service ensures your business name change is completed correctly with all necessary updates to maintain legal compliance and operational continuity.'
    ],
    benefits: [
      { title: 'Complete Service', description: 'Handle all aspects of legal name change.' },
      { title: 'Compliance', description: 'Ensure all required filings and updates are completed.' },
      { title: 'Agency Coordination', description: 'Coordinate updates with IRS, state agencies, and banks.' },
      { title: 'Continuity', description: 'Maintain business continuity during transition.' },
      { title: 'Documentation', description: 'Receive all updated corporate documents.' },
      { title: 'Expert Guidance', description: 'Professional guidance throughout process.' }
    ],
    process: [
      { title: 'Assessment & Planning', description: 'Evaluate current status and plan all necessary steps for successful completion.' },
      { title: 'Documentation & Filing', description: 'Prepare and file all required documents with state and federal authorities.' },
      { title: 'Verification & Finalization', description: 'Ensure proper processing, obtain confirmations, and finalize all requirements.' }
    ],
    pricing: [
      {
        name: 'Basic',
        description: 'Essential formation',
        price: '$299',
        period: '+ state fees',
        features: [
          'Entity formation filing',
          'Name availability check',
          'EIN application',
          'Basic documents',
          'Email support',
          'Document delivery'
        ]
      },
      {
        name: 'Professional',
        description: 'Complete package',
        price: '$599',
        period: '+ state fees',
        featured: true,
        features: [
          'Everything in Basic',
          'Custom agreements',
          'Tax consultation',
          'Compliance setup',
          'Registered agent (1 year)',
          'Priority processing',
          'Phone support'
        ]
      },
      {
        name: 'Enterprise',
        description: 'Full-service solution',
        price: '$999',
        period: '+ state fees',
        features: [
          'Everything in Professional',
          'Multi-state filing',
          'Advanced structuring',
          'Annual compliance',
          'Quarterly reviews',
          'Dedicated attorney',
          'Unlimited consultations'
        ]
      }
    ],
    faqs: [
      { question: 'Why change my company name legally?', answer: 'Legal name changes are required to operate under a new name, update contracts, and maintain compliance with state requirements.' },
      { question: 'How long does the process take?', answer: 'State processing typically takes 2-4 weeks, though expedited filing is available in many states.' },
      { question: 'Do I need a new EIN?', answer: 'No, EIN remains the same but you must notify the IRS of the name change for proper tax record updates.' },
      { question: 'What about DBA names?', answer: 'If using a DBA ("doing business as"), you can operate under that name without changing your legal entity name.' },
      { question: 'Will I need new contracts?', answer: 'Existing contracts remain valid, but new contracts should use the new legal name. Some may require amendments.' },
      { question: 'What about bank accounts?', answer: 'Bank accounts can be updated to reflect new name without opening new accounts, typically requiring updated articles of organization.' },
      { question: 'Does this affect my trademark?', answer: 'Trademark registrations are separate. If your trademark includes your company name, you may need to file a new trademark application.' },
      { question: 'What happens to business licenses?', answer: 'Business licenses typically need to be updated or reissued in the new name, though license numbers may remain the same.' }
    ]
  };

  return <ServiceTemplate {...data} />;
}
